import { groupBy, sortBy } from "lodash";
import { usePreloadStore } from "@/Tailwind/Stores/preload";

export const useTenantCategories = (tenantId) => {
    const preloadStore = usePreloadStore();
    let categories = preloadStore.categories;

    return categories
        .filter((category) => !tenantId || category.tenant_id === tenantId)
        .map((category) => ({
            label: category.name,
            value: category.id,
            ...category,
        }));
};

export const useCategories = (tenantIds) => {
    const preloadStore = usePreloadStore();
    let categories = preloadStore.categories;

    categories = Object.entries(groupBy(categories, "name")).map(
        ([name, tenantCategory]) => ({
            // Return label and value propertie for generic filter use
            label: name,
            value: tenantCategory.map((tenantCategory) => tenantCategory.id),
            tenantIds: tenantCategory.map(
                (tenantCategory) => tenantCategory.tenant_id
            ),
        })
    );

    if (Array.isArray(tenantIds)) {
        categories = categories.filter((category) =>
            tenantIds.every((tenantId) => category.tenantIds.includes(tenantId))
        );
    }

    if (!Array.isArray(tenantIds) && tenantIds) {
        categories = categories.filter((category) =>
            category.tenantIds.includes(tenantIds)
        );
    }

    return sortBy(categories, "name");
};
